// import React, { useState } from 'react';
// import Header from './components/Header';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import About from './components/About';
// import Courses from './components/Courses';
// import Contact from './components/Contact';
// import Login from './components/Login';
// import Principal from './components/Principal';
// import Achievements from './components/Achievements';
// import Events from './components/Events';
// import Placement from './components/Placement';
// import Gallery from './components/Gallery';

// import './App.css';

// function App() {
//   const [showLogin, setShowLogin] = useState(false);

//   return (
//     <div className="app">
//       <Header onLoginClick={() => setShowLogin(true)} />
//       <Navbar />
//       <Hero />
//       <About />
//       <Courses />
//       <Principal />
//       <Achievements />
//       <Events />
//       <Placement />
//       <Gallery />
      
//       <Contact />
//       {/* <Notifications /> */}
//       <footer className="footer">
//         <p>© 2026 Hope Nursing College. All Rights Reserved.</p>
//       </footer>

//       {showLogin && <Login onClose={() => setShowLogin(false)} />}
//     </div>
//   );
// }

// export default App;



import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Principal from './components/Principal';
import Courses from './components/Courses';
import Achievements from './components/Achievements';
import Events from './components/Events';
import Placement from './components/Placement';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import LoginModal from './components/LoginModal';
import DashboardLayout from './components/DashboardLayout';
import DashboardHome from './pages/DashboardHome';
import './App.css';

function AppContent() {
  const { isAuthenticated, logout, user, login } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();

  const handleLoginSuccess = (role) => {
    login(role);
    setShowLogin(false);
    navigate('/dashboard');
  };

  if (isAuthenticated) {
    return (
      <Routes>
        <Route path="/dashboard/*" element={<DashboardLayout user={user} onLogout={logout} />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    );
  }

  return (
    <>
      <Header onLoginClick={() => setShowLogin(true)} />
      <Navbar />
      <Hero />
      <About />
      <Principal />
      <Courses />
      <Achievements />
      <Events />
      <Placement />
      <Gallery />
      <Contact />
      <footer className="footer">© 2026 Hope International Academy. All Rights Reserved.</footer>
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} onLogin={handleLoginSuccess} />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}